import { render } from "./LiveDentalAdvisory.vue?vue&type=template&id=56c2df43&scoped=true"
import script from "./LiveDentalAdvisory.vue?vue&type=script&lang=js"
export * from "./LiveDentalAdvisory.vue?vue&type=script&lang=js"

import "./LiveDentalAdvisory.vue?vue&type=style&index=0&id=56c2df43&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c2df43"]])

export default __exports__